import React, {memo} from "react";

export const IconUploadContractSheet = memo(({color, width, height, addClass}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || "20"}
      height={height || "20"}
      viewBox="0 0 20 20"
      fill="none"
      className={addClass}
    >
      <path
        d="M17.854 5.146L13.354 0.646C13.26 0.552 13.133 0.5 13 0.5H3.5C2.673 0.5 2 1.173 2 2V18C2 18.827 2.673 19.5 3.5 19.5H16.5C17.327 19.5 18 18.827 18 18V5.5C18 5.367 17.947 5.24 17.854 5.146ZM16.793 5.5H13.5C13.224 5.5 13 5.276 13 5V1.707L16.793 5.5ZM16.5 18.5H3.5C3.224 18.5 3 18.276 3 18V2C3 1.724 3.224 1.5 3.5 1.5H12V5C12 5.827 12.673 6.5 13.5 6.5H17V18C17 18.276 16.776 18.5 16.5 18.5Z"
        fill={color || "black"}
      />
      <path
        d="M13.3532 11.6462L10.3532 8.64625C10.1582 8.45125 9.84125 8.45125 9.64625 8.64625L6.64625 11.6462C6.45125 11.8412 6.45125 12.1583 6.64625 12.3533C6.84125 12.5483 7.15825 12.5483 7.35325 12.3533L9.50025 10.2072V16C9.50025 16.276 9.72425 16.5 10.0003 16.5C10.2763 16.5 10.5002 16.276 10.5002 16V10.2072L12.6473 12.3533C12.7453 12.4513 12.8733 12.4992 13.0002 12.4992C13.1272 12.4992 13.2562 12.4503 13.3532 12.3533C13.5482 12.1583 13.5482 11.8412 13.3532 11.6462Z"
        fill={color || "black"}
      />
    </svg>
  );
});
